<template>
  <el-table-column
    prop="id"
    label="#"
    fixed
    width="70"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-link
        @click="$router.replace('/docket/dockets/view/' + scope.row.id)"
        type="primary"
        style="display: inline;"
      >
        {{ scope.row.id }}
      </el-link>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'id',
  };
</script>
